import { createFileRoute } from '@tanstack/react-router';
import ChainsListPage from '../../views/dashboard-chains';

export const Route = createFileRoute('/dashboard/chains/')({
  component: ChainsListPage,
});
